export const sizes = {
  mobile_small: "320px",
  mobile_medium: "625px",
  ipad: "845px",
  tablet: "955px",
  laptop: "1248px",
};

export const device = {
  mobile_small: `(max-width: ${sizes.mobile_small})`,
  mobile_medium: `(max-width: ${sizes.mobile_medium})`,
  ipad: `(max-width: ${sizes.ipad})`,
  tablet: `(max-width: ${sizes.tablet})`,
  laptop: `(max-width: ${sizes.laptop})`,
};
